import React, { useContext, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { MessageContext } from "../../../../common/message/index";
import { GET } from "../../../../utils/fetchUtil";
import ElectionResultsDesktop from "./ElectionResultsDesktop";

function VoteResults() {
  const { t } = useTranslation();
  const message = useContext(MessageContext);
  const { id } = useParams();
  const [results, setResults] = useState({});
  const history = useHistory();
  let electionDetail = history.location.state;

  useEffect(() => {
    GET(
      "/vote?electionId=" + id,
      (response) => {
        setResults(response);
      },
      (error) => {
        message.toggle({
          title: t("requests.overview.supplement.infoBar.errorTitle"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, [id]);

  return (
    <ElectionResultsDesktop
      results={results}
      typeName={electionDetail.title}
      generatedId={electionDetail.id}
    />
  );
}

export default VoteResults;
